/* Sage Custom Code Start (Oct 2025) */
/*rewrote the full file at random for better (open) and (close) behaviour across mobile and desktop browsers*/
/*also added free shipping progress bar javascript function*/

/* ================================
   Free Shipping Progress Bar
================================ */

function updateFreeShippingBar(cartTotal){
  const threshold = 12000;

  const applyUpdate = () => {
    const progressBar = document.querySelector(".shipping-progress-bar");
    const text = document.querySelector(".free-shipping-text");

    if(!progressBar || !text) return false;

    if(cartTotal >= threshold){
      text.innerHTML = "Your bag qualifies for free shipping ✨";
      progressBar.style.width = "100%";
    } else {
      const remaining = Math.ceil((threshold - cartTotal) / 100);
      text.innerHTML = `You're $${remaining} away from free shipping`;
      const progress = (cartTotal / threshold) * 100;
      progressBar.style.width = progress + "%";
    }

    return true;
  };

  // Try immediately
  if (applyUpdate()) return;

  // Retry if DOM not ready or got replaced
  let attempts = 0;
  const interval = setInterval(() => {
    if (applyUpdate() || attempts > 10) {
      clearInterval(interval);
    }
    attempts++;
  }, 120);
}

/* ================================
   Imports
================================ */

import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/* ================================
   Cart Drawer Component
================================ */

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener('cart:update', this.#handleCartUpdate);

    /* Run free shipping bar on page load */
    this.#waitForCartData().then((cart) => {
      if(cart){
        updateFreeShippingBar(cart.total_price);
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener('cart:update', this.#handleCartUpdate);
  }

  /* ================================
     When Product Is Added
  ================================= */

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.#waitForCartData().then((cart) => {
        if(cart){
          updateFreeShippingBar(cart.total_price);
        }
        setTimeout(() => this.open(), 150);
      });
    }
  };

  /* ================================
     When Cart Updates
  ================================= */

  #handleCartUpdate = async () => {
    const cart = await this.#waitForCartData();
    if(cart){
      updateFreeShippingBar(cart.total_price);
    }
    if (this.hasAttribute('open')) {
      setTimeout(() => {
        if (!this.hasAttribute('open')) {
          this.open();
        }
      }, 100);
    }
  };

  /* ================================
     Wait For Cart Data
  ================================= */

  async #waitForCartData(attempt = 1) {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      if (typeof data.item_count !== 'undefined') {
        return data;
      }
    } catch (e) {
      console.warn('[CartDrawer] waitForCartData error', e);
    }
    if (attempt < 3) {
      await new Promise(r => setTimeout(r, 150));
      return this.#waitForCartData(attempt + 1);
    }
    return null;
  }

  /* ================================
     Open Drawer
  ================================= */

  async open() {
  const cart = await this.#waitForCartData();
  if(cart){
  updateFreeShippingBar(cart.total_price);
  }
    this.showDialog();
    setTimeout(() => {
      if (!this.hasAttribute('open')) {
        this.showDialog();
      }
    }, 200);

    /* Prevent payment terms CTA overlap */

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }
  close() {
   this.closeDialog();
  }
}

/* ================================
   Register Component
================================ */

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/* ================================
   Extra Page Load Refresh
================================ */

  async function refreshFreeShippingBar() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  updateFreeShippingBar(cart.total_price);
}

document.addEventListener("DOMContentLoaded", () => {
refreshFreeShippingBar();

  /* Run again after Shopify finishes rendering */

  setTimeout(refreshFreeShippingBar, 800);
  setTimeout(refreshFreeShippingBar, 1600);

});

const cartDrawer = document.querySelector('cart-drawer-component');

if (cartDrawer) {
  const observer = new MutationObserver(() => {
    refreshFreeShippingBar();
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}